import * as React from 'react';
import {Audit, Certification, Project} from '../../../../store/projects/commonTypes';
import {dateTimeFormatter, dateTimeGetter, formatDate, formatDateTime} from '../../../../utils/utils';
import {ProjectStatus} from '../../../../store/projects/commonTypes';
import {getOptionLabel, projectStatusOptions} from '../../../../utils/utils';
import {DataGrid, GridCellParams, GridColDef} from '@mui/x-data-grid';
import {Button, Link} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import {Assignment, Download, FilePresent, Report} from "@mui/icons-material";
import SecurableDownloadLink from "../../../application/SecurableDownloadLink";
import {User} from "oidc-client";
import Stack from "@mui/material/Stack";

export interface AuditsProps {
    audits: Audit[];
    onOpenAudit: (certificationId: string) => void;
    onOpenNewUploadForm: () => void;
    allowToAddReport: boolean;
    user: User;
    showError: (error) => void;
}

export default class Audits extends React.Component<AuditsProps> {
    public render() {
        const columns: GridColDef[] = [
            {field: 'number', headerName: 'QA-nummer', width: 100},
            {field: 'status', headerName: 'Status', width: 150},
            {
                field: '', headerName: 'Nedlastinger', width: 100, renderCell: (params: GridCellParams) => (
                    <Stack direction="row" gap={1}>
                        <SecurableDownloadLink user={this.props.user}
                                               tooltip={"Scoringsrapport"}
                                               showError={error => this.props.showError(error)}
                                               path={`/api/certification/audits/${(params.row as Audit).id}/scoringreport`}><FilePresent/></SecurableDownloadLink>
                        {(params.row as Audit).qaReportInternalLink && (
                            <SecurableDownloadLink user={this.props.user}
                                                   tooltip={"QA-Rapport"}
                                                   showError={error => this.props.showError(error)}
                                                   path={`/api/certification/audits/${(params.row as Audit).id}/qareport`}><Assignment/></SecurableDownloadLink>
                        )}
                    </Stack>
                )
            },
            {
                field: 'created',
                headerName: 'Opprettet den',
                width: 150,
                valueGetter: dateTimeGetter,
                valueFormatter: dateTimeFormatter,
                renderCell: (params: GridCellParams) => (
                    <Link href="#" onClick={(e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
                        e.preventDefault();
                        this.props.onOpenAudit((params.row as Audit).id);
                    }
                    }>{params.formattedValue}</Link>
                ),
            }
        ];

        return (
            <React.Fragment>
                <div className="row">
                    <div className="col-sm-6 mb-4 d-flex align-items-center">
                        <h4>QA–prosess og status</h4>
                    </div>
                    {this.props.allowToAddReport && (
                        <div className="col-sm-6 mb-4 d-flex align-items-center justify-content-end">
                            <Button
                                color="primary"
                                variant="contained"
                                onClick={(event: React.MouseEvent<HTMLButtonElement, Event>) => this.props.onOpenNewUploadForm()}
                                startIcon={<AddIcon/>}
                            >
                                Last opp scoringsrapport
                            </Button>
                        </div>
                    )}
                </div>
                <div className="table-container">
                    <DataGrid columns={columns} rows={this.props.audits} pageSize={5} autoHeight
                              disableSelectionOnClick={true}/>
                </div>
            </React.Fragment>
        );
    }
}